'use client';

import { JoyrideTour } from './JoyrideTour';
import { inboxTourSteps } from './inboxTourSteps';

/**
 * Per-feature tour for the unified inbox: auto-launches once (localStorage-
 * backed under `tour:seen:inbox`), then never again.
 *
 * Visibility is gated centrally in `JoyrideTour` (logged-in users only), so
 * this wrapper carries no per-feature conditions of its own.
 */
export function InboxTour() {
  return <JoyrideTour name='inbox' steps={inboxTourSteps} auto />;
}
